import * as DefaultSchemaCollaboratorsConfigurationDAO from 'auth/DefaultSchemaCollaboratorsConfigurationDAO';
import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export async function updateDefaultSchemaCollaboratorsConfiguration(
  defaultSchemaCollaboratorsConfigurationId: string,
  data: DefaultSchemaCollaboratorsConfigurationDAO.UpdateDefaultSchemaCollaboratorsConfigurationRequest
): Promise<void> {
  const response =
    await DefaultSchemaCollaboratorsConfigurationDAO.updateDefaultSchemaCollaboratorsConfiguration(
      defaultSchemaCollaboratorsConfigurationId,
      data
    );
  writeFragmentsToCache(getFragmentWrapper('DefaultSchemaCollaboratorsConfiguration'), [response]);
}
